export default "__VITE_ASSET__kIrLj_xt__"